var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission32On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.35664H16.6537C15.5126 6.35664 14.4663 5.7011 13.9605 4.67832C13.4546 3.65554 12.4083 3 11.2673 3H7C5.34315 3 4 4.34315 4 6V14.8182H11.1114C12.3321 14.8182 13.4258 15.5601 13.9241 16.6745C13.9552 16.7441 13.9867 16.8141 14.0184 16.8841C14.4646 17.8694 15.4593 18.4545 16.5409 18.4545H21C22.6569 18.4545 24 17.1114 24 15.4545V9.35664C24 7.69979 22.6569 6.35664 21 6.35664Z",
    fill: "#682C78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.8182H11.1114C12.3321 14.8182 13.4258 15.5601 13.9241 16.6745C13.9552 16.7441 13.9867 16.8141 14.0184 16.8841C14.4646 17.8694 15.4593 18.4545 16.5409 18.4545H21C22.6569 18.4545 24 17.1114 24 15.4545V9.35664C24 7.69979 22.6569 6.35664 21 6.35664H16.6537C15.5126 6.35664 14.4663 5.7011 13.9605 4.67832V4.67832C13.4546 3.65554 12.4083 3 11.2673 3H7C5.34315 3 4 4.34315 4 6V25.2727",
    stroke: "#682C78",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission32On);
export default __webpack_public_path__ + "static/media/mission_32_on.fe495019dece4f3609cafddbee16ef2a.svg";
export { ForwardRef as ReactComponent };